import { render, staticRenderFns } from "./RsaConfigurazioneStrutturaProvenienzaViewPage.vue?vue&type=template&id=2e42001e"
import script from "./RsaConfigurazioneStrutturaProvenienzaViewPage.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneStrutturaProvenienzaViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports